import React, { useState, useEffect } from "react";
import kitchenImage from "../assets/kitchen.jpg"; // Default image
import interiorImage from "../assets/interior.jpg"; // Interior image
import exteriorImage from "../assets/exterior.jpg"; // Exterior image
import otherImage from "../assets/other.jpg"; // Other image
import cloudBg from "../assets/cloudbg.png"; // Background image

const Services: React.FC = () => {
  const [activeTab, setActiveTab] = useState("Interior");
  const [imageSrc, setImageSrc] = useState(kitchenImage);
  const [fadeClass, setFadeClass] = useState("");

  useEffect(() => {
    // Reset the fade-in class before applying it
    setFadeClass(""); // Clear the class to reset the animation
    const timer = setTimeout(() => setFadeClass("fade-in-bottom"), 50); // Add a slight delay
    return () => clearTimeout(timer); // Cleanup the timer
  }, [activeTab]);

  useEffect(() => {
    switch (activeTab) {
      case "Interior":
        setImageSrc(interiorImage);
        break;
      case "Exterior":
        setImageSrc(exteriorImage);
        break;
      case "Other":
        setImageSrc(otherImage);
        break;
      default:
        setImageSrc(kitchenImage);
    }
  }, [activeTab]);

  const handleMouseEnter = (tab: string) => {
    setActiveTab(tab);
  };

  return (
    <section
      id="services"
      className="relative bg-cover bg-center bg-no-repeat flex items-center justify-center text-white py-10 pb-20 px-6"
      style={{
        backgroundImage: `linear-gradient(to left, rgba(0, 0, 0, 0.6) 16.67%, rgba(0, 0, 0, 0.3) 50%, transparent 66.67%), url(${cloudBg})`,
        backgroundPosition: "right center",
        backgroundSize: "cover",
      }}
    >
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black opacity-50"></div>
      <h2 className="absolute top-0 left-0 z-10 w-full text-4xl md:text-5xl text-center font-bold py-10 mb-10 text-[#1E3A8A]">
        Services
      </h2>
      <div className="container mx-auto flex flex-col md:flex-row pt-20 items-start md:items-center space-y-6 md:space-y-10 min-h-600px">
        <div className="w-full md:w-2/5 relative">
          <img
            src={imageSrc}
            alt={activeTab}
            className={`w-full object-cover rounded-lg shadow-lg ${fadeClass}`}
          />
        </div>
        <div className="w-full md:w-3/5 relative flex flex-col justify-start md:justify-center text-center md:text-left px-4 md:px-10 space-y-2">
          <div className="sticky z-10 bg-black bg-opacity-50 py-4">
            <div className="flex justify-center md:justify-center space-x-4">
              <button
                className={`tab ${activeTab === "Interior" && "active"}`}
                onMouseEnter={() => handleMouseEnter("Interior")}
              >
                Interior
              </button>
              <button
                className={`tab ${activeTab === "Exterior" && "active"}`}
                onMouseEnter={() => handleMouseEnter("Exterior")}
              >
                Exterior
              </button>
              <button
                className={`tab ${activeTab === "Other" && "active"}`}
                onMouseEnter={() => handleMouseEnter("Other")}
              >
                Other
              </button>
            </div>
          </div>
          <div className="pl-2 tab-content h-[400px] overflow-y-auto">
            {activeTab === "Interior" && (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-lg md:text-xl leading-relaxed">
                <ul className="pl-6 space-y-2 text-left fade-in-bottom">
                  <li>Toilet Replacement</li>
                  <li>Faucet Replacement</li>
                  <li>Rolled Vinyl Floor Installation</li>
                  <li>Tile Floor Installation / Repair</li>
                  <li>Luxury Vinyl Plank Installation</li>
                  <li>Tile Wall Installation / Repair</li>
                  <li>Ceiling Fan Installation</li>
                  <li>Painting (Up to 10' above ground)</li>
                  <li>Wallpaper Removal</li>
                  <li>Furniture Assembly</li>
                </ul>
                <ul className="pl-6 pr-6 space-y-2 text-left fade-in-bottom">
                  <li>Sump Pump Replacement</li>
                  <li>Garbage Disposal Replacement</li>
                  <li>Dishwasher Replacement</li>
                  <li>Refrigerator Replacement</li>
                  <li>Electric Range Replacement</li>
                  <li>Electric Water Heater Replacement</li>
                  <li>Outlet Replacement</li>
                  <li>Switch Replacement</li>
                  <li>Full Room Remodeling</li>
                  <li>Basement Bathroom Addition</li>
                </ul>
              </div>
            )}
            {activeTab === "Exterior" && (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-lg md:text-xl leading-relaxed">
                <ul className="pl-6 space-y-2 text-left fade-in-bottom">
                  <li>Privacy Fence Removal / Install</li>
                  <li>Split Rail Fence Removal / Install</li>
                  <li>Wood Deck Removal / Install</li>
                  <li>Composite Deck Removal / Install</li>
                  <li>Shed Removal / Install</li>
                  <li>Minor Landscaping</li>
                </ul>
                <ul className="pl-6 pr-6 space-y-2 text-left fade-in-bottom">
                  <li>Painting (Up to 10' above ground)</li>
                  <li>Window Replacement</li>
                  <li>Door Replacement</li>
                  <li>Gutter Cleaning (Up to 10' above ground)</li>
                  <li>Playset Construction</li>
                </ul>
              </div>
            )}
            {activeTab === "Other" && (
              <ul className="pl-6 text-lg text-left md:text-xl leading-relaxed space-y-2 fade-in-bottom">
                <li>
                  Even if it's not listed, please feel free to contact us!
                </li>
                <li>913-443-8644</li>
                <li>
                  <a href="mailto:haydenhomeservicesllc@gmail.com?subject=Information Request from Website">
                    haydenhomeservicesllc@gmail.com
                  </a>
                </li>
              </ul>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
